<script lang="ts">
  import { EditorJs } from 'query-strapi-v4';
  type Block = $$Generic<EditorJs.Paragraph | undefined>;
  export let block = undefined as Block;
  import { findReplaceLinksInText } from './handle-links';

  //TODO: UNIT TEST
  // Set external links to target _blank and append an icon
  const cleanText = (text: string) => {
    const replacedTextWithLinks = findReplaceLinksInText(text);
    const codeRegex = /<code class="inline-code">(.*?)<\/code>/g;
    const replacedCode = replacedTextWithLinks.replace(
      codeRegex,
      '<code class="relative rounded bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold">$1</code>'
    );
    // also replace <mark class="bg-muted-foreground/50 font-semibold"> with <mark class="bg-muted font-semibold text-foreground">
    const markRegex = /<mark class="cdx-marker">(.*?)<\/mark>/g;
    const replacedMark = replacedCode.replace(
      markRegex,
      '<mark class="bg-muted font-semibold text-foreground">$1</mark>'
    );
    return replacedMark;
  };
</script>

<p class="leading-7 [&:not(:first-child)]:mt-6">
  {@html cleanText(block.data.text)}
</p>
